import React from 'react';

import ACT from './exams/act';

interface Props {
  examName: string;
}

const AdditionalContentCard = (props) => {
  const slug = props.examName.trim().toLowerCase().replace(/ /g, '_');

  const DefaultAdditionalContentCard = () => null;

  const ExamAdditionalContentCard = {
    act: ACT
  }[slug] || DefaultAdditionalContentCard;

  return <ExamAdditionalContentCard />;
};

export default AdditionalContentCard;
